import { RouterProvider } from 'react-router-dom';
import './App.css';
import { router } from './routes';
import { useEffect } from 'react';
import { setFlags, setWindowFlags } from './utils/main.js';



function App() {
  useEffect(() => {
    setFlags();
    setWindowFlags("chatpdfv2.ai-pro.org");
  }, []);
  return (
    <>
      <RouterProvider router={router} />
    </>
  );
}

export default App;
